import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
    Input,
} from '@angular/core';
import {
    IMachine,
    ISession,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import { ODataQueryOptions } from '@services';
import { SessionsService } from '@services/session.service';

@Injectable()
export class MachineRobotVersionSource implements IGridSource<ODataQueryOptions, ODataResponse<ISession>> {
    public machineId!: number;

    public get mapper() {
        return this._sessions.mapper;
    }

    constructor(
        private _sessions: SessionsService,
    ) { }

    public get(qo: ODataQueryOptions) {
        return this._sessions.getByMachineId(this.machineId, qo);
    }
}

@Component({
    selector: 'ui-machine-robot-versions',
    templateUrl: './machine-robot-versions.grid.html',
    providers: [
        SessionsService,
        {
            provide: GRID_SERVICE,
            useClass: MachineRobotVersionSource,
            deps: [SessionsService],
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MachineRobotVersionsGridComponent extends ODataGridComponent<ISession, number> {

    @Input()
    public set machine(value: IMachine) {
        const svc = (this._service as MachineRobotVersionSource);
        if (
            !svc ||
            !value ||
            svc.machineId === value.id
        ) { return; }

        svc.machineId = value.id;
        this._refresh$.next();
    }
}
